<template>
  <template v-for="snode in templateNodes" :key="snode.tag + snode.index">
    <component :is="snode.tag">
      <template v-for="cnode in snode.content">
        <template v-if="cnode.type === 'text'">
          {{ cnode.text }}
        </template>
        <template v-else-if="cnode.type === 'slot'">
          <slot :name="cnode.slot" v-bind="cnode">
            <span :key="cnode.index" v-html="sanitize('{{' + cnode.slot + ':' + cnode.slug + '}}')"></span>
          </slot>
        </template>
      </template>
    </component>
  </template>
</template>

<script>
import { computed, onMounted } from 'vue';
import sanitize from '@/utils/sanitizer.js';

export default {
  emits: ['loaded'],
  props: {
    template: {
      type: String,
      required: true,
    },
    isMarkdown: {
      type: Boolean,
      default: false,
    },
    unescape: {
      type: Boolean,
      default: false,
    },
  },
  async setup(props, ctx) {
    const mdTags = [
      {
        md: '\\*',
        tag: 'b',
      },
      {
        md: '_',
        tag: 'i',
      },
    ];
    const contentPattern = new RegExp('({{.*?}})', 'gi');
    const stylePattern = new RegExp(
      '(' +
        mdTags
          .map((t) => {
            const regexTag = `[^\]${t.md}`;
            return `${regexTag}.*?${regexTag}`;
          })
          .join('|') +
        ')',
      'gi',
    );

    const templateNodes = computed(() => {
      if (props.isMarkdown && props.template) {
        const nodes = props.template.split(stylePattern).filter((x) => x);
        return nodes.map((nodeText, i) => {
          for (let i = 0; i < mdTags.length; i++) {
            const pattern = new RegExp(`(?<pre>[^\\\\])${mdTags[i].md}(?<content>.*)${mdTags[i].md}`);
            const m = nodeText.match(pattern);
            if (m) {
              return {
                index: i,
                tag: mdTags[i].tag,
                content: makeContentNodes(m.groups.pre + m.groups.content),
              };
            }
          }
          return {
            index: i,
            tag: 'span',
            content: makeContentNodes(nodeText),
          };
        });
      } else {
        return [
          {
            index: 0,
            tag: 'span',
            content: makeContentNodes(props.template),
          },
        ];
      }
    });

    const makeContentNodes = (content) => {
      const nodes = content.split(contentPattern).filter((x) => x);
      return nodes.map((nodeText, i) => {
        if (nodeText.startsWith('{{') && nodeText.endsWith('}}')) {
          nodeText = nodeText.substring(2, nodeText.length - 2);
          const tparts = nodeText.split(':');
          return {
            index: i,
            type: 'slot',
            slot: tparts[0],
            slug: tparts[1],
          };
        } else {
          return {
            index: i,
            type: 'text',
            text: retouchText(nodeText),
          };
        }
      });
    };

    const retouchText = (text) => {
      let result = text;
      if (props.unescape) {
        result = result.replace(/\\n/gi, '\n');
      }
      if (props.isMarkdown) {
        result = result.replace(/\\\*/gi, '*');
      }
      return result;
    };

    onMounted(() => {
      const slugs = [];

      templateNodes.value?.forEach((node) => {
        node.content.forEach((content) => {
          if (content.slug) slugs.push(content.slug);
        });
      });

      ctx.emit('loaded', slugs);
    });

    return {
      templateNodes,
      sanitize,
    };
  },
};
</script>

<style scoped>
span {
  white-space: pre-line;
}
</style>
